class SwtIframeResizer extends HTMLElement {
	constructor() {
		super()
	}

	async connectedCallback() {
		const iframe = this.querySelector('iframe')

		if (!iframe) {
			return
		}

		iframe.addEventListener('load', async () => {
			const { default: iFrameResize } = await import(
				/* webpackChunkName: "iframe-resizer" */ 'iframe-resizer'
			)
			iFrameResize.iframeResizer(
				{
					log: true,
					heightCalculationMethod: 'bodyScroll',
					warningTimeout: 0,
				},
				iframe,
			)
		})
	}
}

// Register the custom element
customElements.define('swt-iframe-resizer', SwtIframeResizer)
